import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export { supabaseUrl, supabaseAnonKey };

// Global 401 handler - called on auth errors to force logout
let onAuthErrorCallback: (() => void) | null = null;

export function setAuthErrorHandler(callback: () => void) {
  onAuthErrorCallback = callback;
}

export function handleAuthError(error: { code?: string; message?: string } | null) {
  if (!error) return false;

  const isAuthError =
    error.code === 'PGRST301' || // JWT expired
    error.code === '401' ||
    error.message?.toLowerCase().includes('jwt') ||
    error.message?.toLowerCase().includes('unauthorized') ||
    error.message?.toLowerCase().includes('not authenticated');

  if (isAuthError && onAuthErrorCallback) {
    console.warn('Auth error detected, forcing logout:', error.message);
    onAuthErrorCallback();
    return true;
  }
  return false;
}
